import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/login/Login.vue';
import Certificate from '@/components/certificate/Certificate.vue';
import Profile from '@/components/profile/Profile.vue';
import Survey from '@/components/survey/Survey.vue';

import Impress from './views/Impress.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import {UserModule} from './store/modules/User';
import {AppModule} from './store/modules/App';

Vue.use(Router);

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
        },
        {
            path: '/logout',
            name: 'logout',
            component: Login,
            beforeEnter: async () => {
                await UserModule.logOutUser();
            }
        },
        {
            path: '/certificate',
            name: 'certificate',
            component: Certificate,
        },
        {
            path: '/impress',
            name: 'impress',
            component: Impress,
        },
        {
            path: '/privacy-policy',
            name: 'privacy-policy',
            component: PrivacyPolicy,
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
        },
        {
            path: '/survey',
            name: 'survey',
            component: Survey,
            beforeEnter: async (to, from, next) => {
                if (UserModule.surveyFinished) {
                    router.push({name: 'certificate'});
                } else {
                    next();
                }
            }
        }
    ],
});

router.beforeEach(async (to, from, next) => {
    AppModule.setShowContent(false);
    if (to.name === ('login' || 'logout') || to.name === 'impress' || to.name === 'privacy-policy'
        || await UserModule.isLoggedIn()) {
        next();
        AppModule.setShowContent(true);
    } else {
        router.push({name: 'login'});
        AppModule.setShowContent(true);
    }
});

export default router;
